import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
interface IAnchors {
    anchorModuleTitle?: string;
    href?: string;
}

interface IArticleAnchorModuleProps extends MappedComponentProperties {
    listType?: string;
    title?: string;
    anchors?: IAnchors[];
}

export const ArticleAnchorModuleEditConfig = {
    emptyLabel: 'Article Anchor Module',
    isEmpty: (props: PropsWithChildren<IArticleAnchorModuleProps>) => {
        return !props || !props.title;
    },
};

const ArticleAnchorModule = (props: PropsWithChildren<IArticleAnchorModuleProps>): JSX.Element => {
    const anchorItems = props.anchors && props.anchors.map((anchor, index) =>
        <li key={index}><a href={`#${anchor.href}`}>{transformHTMLParserLinks(wrapTrademarkSuperscript(anchor.anchorModuleTitle))}</a></li>,
    );
    return (
        <div id='article-anchor-module' className='ArticleAnchorModule'>
            <p className='mb-5 font-bold text-2xl' >{transformHTMLParserLinks(wrapTrademarkSuperscript(props.title))}</p>
            <div className='w-fit'>
                {props.listType === 'ul' ?
                    <ul>
                        {anchorItems}
                    </ul>
                    :
                    <ol>
                        {anchorItems}
                    </ol>
                }
                <hr className={'ArticleAnchorModule__hr'}/>
            </div>
        </div>
    );
};

export default ArticleAnchorModule;
